import { LOGOUT } from '../../../store/Types';

export const ALL_ESTADOS = 'ALL_ESTADOS';
export const LOADING_ALL_ESTADOS = 'LOADING_ALL_ESTADOS';
export const ACTIVO_ESTADOS = 'ACTIVO_ESTADOS';
export const ALERT_VIEW_ESTADOS = 'ALERT_VIEW_ESTADOS';
export const PARAMS_ESTADOS = 'PARAMS_ESTADOS';
export const SEARCH_ESTADOS = 'SEARCH_ESTADOS';

const initialState = {
  all: [],
};

export const estadosReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_ESTADOS:
      return {
        ...state,
        all: action.payload.data,
      };
    case LOADING_ALL_ESTADOS:
      return {
        ...state,
        loadingAll: action.payload,
      };
    case LOGOUT:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};
